"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _InputGroupWithSubdomain = _interopRequireDefault(require("../../../ui-components/InputGroupWithSubdomain"));

var ConsumerAppInstallation = function ConsumerAppInstallation(_ref) {
  var instanceTypes = _ref.instanceTypes,
      type = _ref.type,
      username = _ref.username,
      instanceUrl = _ref.instanceUrl,
      appConsumerKey = _ref.appConsumerKey;
  return (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "panel-form-input qa-form-type"
  }, (0, _preact.h)(_RadioInputGroup.default, {
    disabled: true,
    title: "Salesforce instance type",
    options: instanceTypes,
    value: type,
    underneath: true
  })), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-username"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    key: "username",
    title: "Salesforce username",
    qaClasses: "qa-username-input",
    value: username,
    disabled: true
  })), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-instance-url"
  }, (0, _preact.h)(_InputGroupWithSubdomain.default, {
    key: "instanceUrl",
    title: "Instance URL",
    qaClasses: "qa-instance-url-input",
    value: instanceUrl,
    disabled: true,
    subdomain: ".salesforce.com"
  })), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-app-consumer-key"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    key: "appConsumerKey",
    title: "Connected app consumer key",
    qaClasses: "qa-app-consumer-key-input",
    value: appConsumerKey,
    disabled: true
  })));
};

var _default = ConsumerAppInstallation;
exports.default = _default;